import React from 'react';
import { MemberFirearmDTO } from '../../services/apiClient';
import { FirearmMakeConstants } from '../../constants/FirearmMakeConstants';
import { FirearmCaliberConstants } from '../../constants/FirearmCaliberConstants';
import ImagePreview from '../../components/common/ImagePreview';
import { Crosshair } from 'lucide-react';

export interface FirearmOption {
  value: string | undefined;
  label: React.ReactNode;
  searchText: string;
}

export function buildFirearmOptions(firearms: MemberFirearmDTO[]): FirearmOption[] {
  return firearms.map((firearm) => {
    const makeTitle =
      firearm.firearmMakeId === FirearmMakeConstants.NOT_ON_LIST
        ? firearm.firearmMakeOther
        : firearm.firearmMake?.title ?? 'Unknown';
    const caliberTitle =
      firearm.firearmCaliberId === FirearmCaliberConstants.NOT_ON_LIST
        ? firearm.caliberOther
        : firearm.caliber?.title ?? 'Unknown';
    const displayName = `${makeTitle} - ${caliberTitle}`;

    return {
      value: firearm.id,
      searchText: `${displayName} ${firearm.description ?? ''}`,
      label: (
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-7 h-7 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
            {firearm.firearmFileId
              ? <ImagePreview fileId={firearm.firearmFileId} size="xs" />
              : <Crosshair className="w-4 h-4 text-gray-400" />
            }
          </div>
          <div className="flex flex-col min-w-0">
            <span className="text-sm text-slate-700 dark:text-slate-200 truncate">{displayName}</span>
            {firearm.description && (
              <span className="text-xs text-slate-700 dark:text-slate-200 truncate">{firearm.description}</span>
            )}
          </div>
        </div>
      ),
    };
  });
}
